// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin: 1.5rem 0 0 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-current {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.platform-search-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 1.5rem;
  margin: 0 auto;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading h1 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 650;
  line-height: 1.3;
}

.page-heading p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.btn-primary,
.btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}
.btn-primary:focus-visible,
.btn-secondary:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
  box-shadow: none;
}
.btn-primary:disabled,
.btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}
.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}
.btn-primary:active:not(:disabled) {
  border-color: var(--ca-primary-darker, #041b38);
  background: var(--ca-primary-darker, #041b38);
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}
.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-hover, #f8faff);
  color: var(--ca-primary-dark, #0d2863);
}

.add-platform-button {
  flex: 0 0 auto;
}

.platform-list-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr) auto;
  align-items: stretch;
  gap: 0.875rem;
  margin-bottom: 1.25rem;
}

.search-field {
  display: flex;
  min-width: 0;
  align-items: stretch;
}

.search-control {
  width: 100%;
  min-width: 0;
  min-height: 2.65rem;
  border: 1px solid var(--ca-input-border, #dfe4ec);
  border-radius: var(--ca-radius-md, 8px);
  background-color: var(--ca-input-bg, #fff);
  color: var(--ca-text-primary, #172033);
  font-size: 0.9rem;
}
.search-control:focus {
  border-color: var(--ca-input-focus, #2850ad);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);
  outline: 0;
}
.search-control::placeholder {
  color: var(--ca-text-muted, #8c96a8);
}

.search-field .search-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.search-submit {
  display: inline-grid;
  width: 2.8rem;
  flex: 0 0 2.8rem;
  place-items: center;
  border: 1px solid var(--ca-primary, #0e2e80);
  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;
  background: var(--ca-primary, #0e2e80);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}
.search-submit:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.clear-search-button {
  justify-self: end;
}

.table-region {
  min-width: 0;
  overflow-x: auto;
}

.inline-loading {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.inline-error {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.75rem 0;
  padding: 0.875rem 1rem;
  border: 1px solid var(--ca-danger, #dc3545);
  border-radius: var(--ca-radius-md, 8px);
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-text-primary, #172033);
}

.inline-retry-button {
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  font-weight: 650;
  text-decoration: underline;
  cursor: pointer;
}

.no-results {
  display: flex;
  min-height: 11rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.5rem;
  color: var(--ca-text-tertiary, #6f7b91);
  text-align: center;
}
.no-results i {
  color: var(--ca-primary-light, #2850ad);
  font-size: 1.75rem;
}
.no-results p {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
}

.list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ca-border-light, #e9edf3);
}

.back-button {
  flex: 0 0 auto;
}

.empty-state {
  display: grid;
  min-height: min(70vh, 42rem);
  place-items: center;
  padding: 2rem 1rem;
}

.empty-state-content {
  width: min(100%, 42rem);
  text-align: center;
}

.empty-state-icon {
  display: grid;
  width: 4.25rem;
  height: 4.25rem;
  place-items: center;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 1.25rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 2rem;
}

.empty-state h1 {
  margin: 0 0 0.65rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2.5vw, 1.75rem);
  font-weight: 650;
  line-height: 1.3;
}

.empty-state p {
  max-width: 35rem;
  margin: 0 auto 1.5rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.98rem;
  line-height: 1.65;
}

.empty-state-action {
  min-height: 2.85rem;
  padding-inline: 1.25rem;
}

.state-panel {
  display: flex;
  min-height: 55vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
}
.state-panel > i {
  margin-bottom: 0.75rem;
  color: var(--ca-danger, #dc3545);
  font-size: 2rem;
}
.state-panel h1 {
  margin: 0 0 0.5rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.4rem;
}
.state-panel p {
  margin: 0 0 1rem;
  color: var(--ca-text-secondary, #4b5870);
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: platform-search-spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1.1rem;
  height: 1.1rem;
  border-width: 2px;
}

.loading-state p {
  margin: 0.8rem 0 0;
}

@keyframes platform-search-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 991.98px) {
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .clear-search-button {
    grid-column: 1/-1;
    justify-self: start;
  }
}
@media (max-width: 767.98px) {
  .breadcrumb {
    margin: 1rem 0 0 1rem;
  }
  .platform-search-page {
    padding: 1rem;
  }
  .page-header {
    flex-direction: column;
    align-items: stretch;
  }
  .add-platform-button {
    align-self: flex-start;
  }
  .platform-list-card {
    padding: 0.875rem;
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
  .clear-search-button {
    grid-column: auto;
    justify-self: start;
  }
  .list-footer {
    flex-direction: column;
    align-items: stretch;
  }
  .back-button {
    align-self: flex-start;
  }
  .list-footer app-pagination {
    max-width: 100%;
    align-self: flex-end;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/zone-management/platform/platform-search/platform-search.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AACF;;AAEA;EACE,mBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6GAAA;AACF;AACE;;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;AACE;;EACE,mBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,4CAAA;EACA,sCAAA;EACA,WAAA;AACF;AACE;EACE,6CAAA;EACA,2CAAA;EACA,WAAA;AACJ;AAEE;EACE,+CAAA;EACA,6CAAA;AAAJ;;AAIA;EACE,2CAAA;EACA,mCAAA;EACA,iCAAA;AADF;AAGE;EACE,wCAAA;EACA,4CAAA;EACA,sCAAA;AADJ;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,YAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAFF;;AAKA;EACE,aAAA;EACA,qEAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,oBAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iDAAA;EACA,uCAAA;EACA,0CAAA;EACA,sCAAA;EACA,iBAAA;AAFF;AAIE;EACE,4CAAA;EACA,gDAAA;EACA,UAAA;AAFJ;AAKE;EACE,oCAAA;AAHJ;;AAOA;EACE,0BAAA;EACA,6BAAA;AAJF;;AAOA;EACE,oBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;EACA,oEAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,uCAAA;AAJF;AAME;EACE,2CAAA;AAJJ;AAOE;EACE,kBAAA;EACA,UAAA;EACA,0CAAA;EACA,mBAAA;AALJ;;AASA;EACE,iBAAA;AANF;;AASA;EACE,YAAA;EACA,gBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,sCAAA;AANF;;AASA;EACE,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;AANF;;AASA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;AANF;AAQE;EACE,uCAAA;EACA,kBAAA;AANJ;AASE;EACE,SAAA;EACA,wCAAA;AAPJ;;AAWA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,qDAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AARF;;AAWA;EACE,uBAAA;EACA,kBAAA;AARF;;AAWA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;EACA,sBAAA;EACA,6CAAA;EACA,iCAAA;EACA,eAAA;AARF;;AAWA;EACE,mBAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,gBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;AARF;;AAWA;EACE,mBAAA;EACA,uBAAA;AARF;;AAWA;EACE,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AARF;AAUE;EACE,sBAAA;EACA,gCAAA;EACA,eAAA;AARJ;AAWE;EACE,kBAAA;EACA,sCAAA;EACA,iBAAA;AATJ;AAYE;EACE,gBAAA;EACA,wCAAA;AAVJ;;AAcA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,oDAAA;AAXF;;AAcA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;AAXF;;AAcA;EACE,kBAAA;AAXF;;AAcA;EACE;IAAK,yBAAA;EAVL;AACF;AAYA;EACE;IACE,oDAAA;EAVF;EAaA;IACE,iBAAA;IACA,mBAAA;EAXF;AACF;AAcA;EACE;IACE,qBAAA;EAZF;EAeA;IACE,aAAA;EAbF;EAgBA;IACE,sBAAA;IACA,oBAAA;EAdF;EAiBA;IACE,sBAAA;EAfF;EAkBA;IACE,iBAAA;EAhBF;EAmBA;IACE,qCAAA;EAjBF;EAoBA;IACE,iBAAA;IACA,mBAAA;EAlBF;EAqBA;IACE,sBAAA;IACA,oBAAA;EAnBF;EAsBA;IACE,sBAAA;EApBF;EAuBA;IACE,eAAA;IACA,oBAAA;EArBF;AACF;AAwBA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,gCAAA;IACA,sCAAA;EAtBF;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin: 1.5rem 0 0 1.5rem;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-current {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-weight: 500;\n}\n\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.platform-search-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 1.5rem;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.page-heading h1 {\n  margin: 0 0 0.35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2vw, 1.7rem);\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.page-heading p {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.btn-primary,\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 2.6rem;\n  padding: 0.65rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: 0.9rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n\n  &:focus-visible {\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n    box-shadow: none;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n}\n\n.btn-primary {\n  border: 1px solid var(--ca-primary, #0e2e80);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary-dark, #0d2863);\n    background: var(--ca-primary-dark, #0d2863);\n    color: #fff;\n  }\n\n  &:active:not(:disabled) {\n    border-color: var(--ca-primary-darker, #041b38);\n    background: var(--ca-primary-darker, #041b38);\n  }\n}\n\n.btn-secondary {\n  border: 1px solid var(--ca-border, #dfe4ec);\n  background: var(--ca-surface, #fff);\n  color: var(--ca-primary, #0e2e80);\n\n  &:hover:not(:disabled) {\n    border-color: var(--ca-primary, #0e2e80);\n    background: var(--ca-surface-hover, #f8faff);\n    color: var(--ca-primary-dark, #0d2863);\n  }\n}\n\n.add-platform-button {\n  flex: 0 0 auto;\n}\n\n.platform-list-card {\n  min-width: 0;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: var(--ca-radius-lg, 12px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\n}\n\n.search-toolbar {\n  display: grid;\n  grid-template-columns: minmax(18rem, 1.6fr) minmax(13rem, 0.8fr) auto;\n  align-items: stretch;\n  gap: 0.875rem;\n  margin-bottom: 1.25rem;\n}\n\n.search-field {\n  display: flex;\n  min-width: 0;\n  align-items: stretch;\n}\n\n.search-control {\n  width: 100%;\n  min-width: 0;\n  min-height: 2.65rem;\n  border: 1px solid var(--ca-input-border, #dfe4ec);\n  border-radius: var(--ca-radius-md, 8px);\n  background-color: var(--ca-input-bg, #fff);\n  color: var(--ca-text-primary, #172033);\n  font-size: 0.9rem;\n\n  &:focus {\n    border-color: var(--ca-input-focus, #2850ad);\n    box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.15);\n    outline: 0;\n  }\n\n  &::placeholder {\n    color: var(--ca-text-muted, #8c96a8);\n  }\n}\n\n.search-field .search-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.search-submit {\n  display: inline-grid;\n  width: 2.8rem;\n  flex: 0 0 2.8rem;\n  place-items: center;\n  border: 1px solid var(--ca-primary, #0e2e80);\n  border-radius: 0 var(--ca-radius-md, 8px) var(--ca-radius-md, 8px) 0;\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: var(--ca-primary-dark, #0d2863);\n  }\n\n  &:focus-visible {\n    position: relative;\n    z-index: 1;\n    outline: 3px solid rgba(40, 80, 173, 0.25);\n    outline-offset: 2px;\n  }\n}\n\n.clear-search-button {\n  justify-self: end;\n}\n\n.table-region {\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.inline-loading {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  min-height: 5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.9rem;\n}\n\n.inline-error {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin: 0.75rem 0;\n  padding: 0.875rem 1rem;\n  border: 1px solid var(--ca-danger, #dc3545);\n  border-radius: var(--ca-radius-md, 8px);\n  background: var(--ca-danger-bg, #fdecef);\n  color: var(--ca-text-primary, #172033);\n}\n\n.inline-retry-button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  font-weight: 650;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.no-results {\n  display: flex;\n  min-height: 11rem;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 1.5rem;\n  color: var(--ca-text-tertiary, #6f7b91);\n  text-align: center;\n\n  i {\n    color: var(--ca-primary-light, #2850ad);\n    font-size: 1.75rem;\n  }\n\n  p {\n    margin: 0;\n    color: var(--ca-text-secondary, #4b5870);\n  }\n}\n\n.list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ca-border-light, #e9edf3);\n}\n\n.back-button {\n  flex: 0 0 auto;\n}\n\n.empty-state {\n  display: grid;\n  min-height: min(70vh, 42rem);\n  place-items: center;\n  padding: 2rem 1rem;\n}\n\n.empty-state-content {\n  width: min(100%, 42rem);\n  text-align: center;\n}\n\n.empty-state-icon {\n  display: grid;\n  width: 4.25rem;\n  height: 4.25rem;\n  place-items: center;\n  margin: 0 auto 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 1.25rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 2rem;\n}\n\n.empty-state h1 {\n  margin: 0 0 0.65rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2.5vw, 1.75rem);\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.empty-state p {\n  max-width: 35rem;\n  margin: 0 auto 1.5rem;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: 0.98rem;\n  line-height: 1.65;\n}\n\n.empty-state-action {\n  min-height: 2.85rem;\n  padding-inline: 1.25rem;\n}\n\n.state-panel {\n  display: flex;\n  min-height: 55vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1rem;\n  text-align: center;\n\n  > i {\n    margin-bottom: 0.75rem;\n    color: var(--ca-danger, #dc3545);\n    font-size: 2rem;\n  }\n\n  h1 {\n    margin: 0 0 0.5rem;\n    color: var(--ca-text-primary, #172033);\n    font-size: 1.4rem;\n  }\n\n  p {\n    margin: 0 0 1rem;\n    color: var(--ca-text-secondary, #4b5870);\n  }\n}\n\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: platform-search-spin 0.8s linear infinite;\n}\n\n.loading-spinner-sm {\n  width: 1.1rem;\n  height: 1.1rem;\n  border-width: 2px;\n}\n\n.loading-state p {\n  margin: 0.8rem 0 0;\n}\n\n@keyframes platform-search-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 991.98px) {\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .clear-search-button {\n    grid-column: 1 / -1;\n    justify-self: start;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .breadcrumb {\n    margin: 1rem 0 0 1rem;\n  }\n\n  .platform-search-page {\n    padding: 1rem;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .add-platform-button {\n    align-self: flex-start;\n  }\n\n  .platform-list-card {\n    padding: 0.875rem;\n  }\n\n  .search-toolbar {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .clear-search-button {\n    grid-column: auto;\n    justify-self: start;\n  }\n\n  .list-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .back-button {\n    align-self: flex-start;\n  }\n\n  .list-footer app-pagination {\n    max-width: 100%;\n    align-self: flex-end;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
